import { FormControl, MenuItem, Select } from "@mui/material";
import React from "react";

const CustomSelect = ({
  selVal,
  selHandle,
  selItems,
  type,
  className,
  label,
  ...rest
}) => {
  return (
    <FormControl>
      <Select
        className={className}
        labelId="select"
        id="demo-simple-select"
        variant={type !== null ? type : "standard"}
        value={selVal}
        defaultValue={selVal}
        // sx={{ borderColor: error ? "var(--error-color)" : "-moz-initial" }}
        onChange={(e) => selHandle(e.target.value)}
        label={label}
        {...rest}
      >
        {selItems?.map((val, index) => (
          <MenuItem
            style={{ fontSize: "18px" }}
            value={val.val ? val.val : index}
            key={index}
          >
            {val.name ? val.name : val}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
